import { Component } from '@angular/core'

@Component({
  template: '<ftr-reset-sent></ftr-reset-sent>',
  standalone: false,
})
export class ResetSentPage {}
